import type { SVGProps } from 'react';

const SvgMinusLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M4 12H20' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
export default SvgMinusLt;
